/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete';
import { makeStyles } from '@mui/styles';
import { Grid, Typography, Button, TextField, FormControl, InputLabel, Select, MenuItem, List, ListItemText, ListItemIcon, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { portalCfg } from '../../config';
import CustomDivider from '../../components/CustomDivider';
import CustomHeader from '../../components/CustomHeader';
import { getAppConfig, getLogo } from '../../utils/commons';
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil';
import { configuration } from '../../config/main.config';
import CustomAlert from '../../components/CustomAlert';
import TermConditionController from '../term-condition/TermConditionController';
import CustomFooter from '../../components/CustomFooter';
import { CloseIcon, PlaceIcon } from '../../components/CustomIcons';
import { HashLink } from 'react-router-hash-link';
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { sortByPrice } from '../../utils/util';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    top: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    bottom: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    package: {
        cursor: 'pointer',
        width: '90%',
        height: 400,
        [theme.breakpoints.up('sm')]: {
            width: '80%',
            height: 400,
        },
        [theme.breakpoints.up('md')]: {
            width: '80%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '94%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '90%',
        },
    },
    item_image: {
        display: 'block',
        margin: 'auto',
        width: '100%',
    },
    item_image_logo: {
        width: '100%',
        height: 300,
        objectFit: 'contain',
    },
    term_condition: {
        cursor: 'pointer'
    },
    address_item: {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderBottom: '1px solid ' + theme.palette.background.primary,
    },
    address_selected: {
        backgroundColor: theme.palette.background.primary,
    },
    canSelected: {
        cursor: 'pointer',
    },
    cantSelected: {
        opacity: 0.7,
    },
    select_container: {
        marginTop: theme.spacing(0.4)
    },
    select_input: {
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        backgroundColor: theme.palette.common.white,
    },
    input: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    input_container: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    inputContainerFocus: {
        border: 'none',
    },
    inputRoot: {
        //color: theme.palette.common.white + "!important",
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        background: theme.palette.common.white
    },
    textArea: {
        // minHeight: theme.spacing(24),
        height: 'auto',
    },
    //add css underline, 
    underline: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        }
    },
    search_by: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    item_address: {
        padding: theme.spacing(1, 2),
    },
    list_item: {
        position: "absolute",
        background: "#eee",
        width: '100%',
        zIndex: 10,
        maxHeight: 200,
        overflow: 'auto'
    }
}));

export default function LandingPageView(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const packagesRef = useRef(null);
    const items = [
        portalCfg.publicPath + "/images/banner/header_one.jpg",
        portalCfg.publicPath + "/images/banner/header_two.jpg"
    ]
    const { showModal, setShowModal, setChoosePackage, showTerm, showListAddresses, setShowListAddresses, choosePackage, packages } = props;

    const appConfig = getAppConfig();
    const content = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.content ? appConfig.about_details.terms_conditions.content : null;
    const urlTerm = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.url ? appConfig.about_details.terms_conditions.url : null;
    const carousels = appConfig && appConfig.creatives && appConfig.creatives.length > 0 ? appConfig.creatives.filter(x => x.usage_type === usage_type.carousel_image) : null;
    // console.log("choosePackage ===", choosePackage);

    useEffect(() => {
        if(!showModal && choosePackage){
            packagesRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "start"
            });
        }
    },[showModal])
    
    return (
        <Grid item xs={12}>
            {carousels && carousels.length > 0 && <Carousel autoPlay showThumbs={false} infiniteLoop={true} showStatus={false}>
                {carousels.map((item, index) => <div key={index}><img src={item.url} alt="Banner"/></div>)}
            </Carousel>}
            <CustomHeader />
            <div>
                <HashLink to="#check_coverage" id='tag-check-coverage' style={{ display: 'none' }}>Check Coverage</HashLink>
                <HashLink to="#packages" id='tag-packages' style={{ display: 'none' }}>Packages</HashLink>
                {/* <Button id="btn-packages" onClick={(event) => scrollToPackages(event)} style={{ display: 'none' }}>Packages</Button> */}
            </div>
            <Grid xs={12} marginTop={5} item container justifyContent="center">
                <CheckCoverage t={t} classes={classes} address={props.address} setAddress={props.setAddress} onCheckCoverage={props.onCheckCoverage}
                    searchType={props.searchType}
                    ispLocation={props.ispLocation}
                    setISPLocation={props.setISPLocation}
                    setSearchType={props.setSearchType}
                />
            </Grid>
            <Grid xs={12} marginTop={5} item container justifyContent="center">
                <SelectPackages 
                    packages={packages} 
                    addressSelected={props.addressSelected}
                    onClickItem={props.onSelectPackage} 
                    choosePackage={choosePackage}
                    packagesRef={packagesRef}
                />
            </Grid>
            <CustomFooter />
            {showModal && <CustomAlert
                open={showModal}
                title={t('has_coverage')}
                isConfirm={true}
                showButtonClose={true}
                customMessage={<ContentHasCoverage t={t} classes={classes} onShowTerm={props.onShowTerm} setShowModal={props.setShowModal} content={content} urlTerm={urlTerm} />}
                onClose={() => {
                    props.setAddressSelected(null);
                    setShowModal(false)
                    setChoosePackage(false);
                }}
                confirmAction={{
                    okAction: () => {
                        setChoosePackage(true);
                        setShowModal(false);
                        // console.log("document.getElementById('tag-packages')===", document.getElementById('tag-packages'));
                        // document.getElementById('tag-packages').click();
                        // document.getElementById('btn-packages').click();
                        // document.getElementById('packages').focus();
                        // scrollToPackages();
                        // packagesRef.current.scrollIntoView({
                        //     behavior: "smooth",
                        // });
                        // document.getElementById('packages').scrollIntoView({ behavior: 'smooth', block: "end", inline: "nearest" });;
                    },
                    okTitle: t('btn_agree'),
                }}
            />}
            {showTerm && <TermConditionController
                open={showTerm}
                onClose={() => props.onShowTerm(false)}
            />}
            {showListAddresses && <CustomAlert
                open={showListAddresses}
                isConfirm={true}
                showButtonClose={true}
                title={t('please_select_address')}
                customMessage={<ListAddresses
                    t={t}
                    classes={classes}
                    addresses={props.addresses}
                    addressSelected={props.addressSelected}
                    setAddressSelected={props.setAddressSelected}
                />}
                onClose={() => {
                    props.setAddressSelected(null);
                    setShowModal(false)
                    setShowListAddresses(false)
                }}
                confirmAction={{
                    okAction: () => {
                        setShowListAddresses(false);
                    },
                    okTitle: t('btn_ok'),
                }}
            />}
        </Grid>
    )
}

function ContentHasCoverage(props) {
    const { t, classes, content, urlTerm } = props;
    let _urlTerm = urlTerm.includes('http') ? urlTerm : 'https://' + urlTerm;
    return (
        <Grid item xs={12}>
            <Typography variant="subtitle2">{t('can_select_package')}</Typography>
            <Typography variant="subtitle2">{t('agree_term')}
                <strong>{content ? <span className={classes.term_condition}
                    onClick={() => {
                        props.onShowTerm(true);
                        props.setShowModal(false)
                    }}>
                </span> : <a href={_urlTerm} target={'_blank'}>{urlTerm}</a>}
                </strong> {t('of_service')}</Typography>
        </Grid>
    );
}

function ListAddresses(props) {
    const { t, classes, addresses, addressSelected, setAddressSelected } = props;

    return (
        <Grid item xs={12}>
            {addresses && addresses.length > 0 && addresses.map((item, index) => {
                return (
                    <Grid item xs={12} key={index} className={addressSelected && addressSelected.objectID === item.objectID ? classes.address_selected : null}>
                        <Typography variant="subtitle2" className={classes.address_item} onClick={() => setAddressSelected(item)}>{item.address}</Typography>
                    </Grid>
                );
            })}
        </Grid>
    );
}

function CheckCoverage(props) {
    const { address, classes, t, setSearchType, searchType, ispLocation, setISPLocation } = props;
    console.log("searchType===", searchType);
    const [hideListItem, setHideListItem] = useState(undefined);
    const [valueAddress, setValueAddress] = useState(null);

    const options = {
        fields: ["address_components", "geometry", "icon", "name"],
        strictBounds: false,
        componentRestrictions: { country: ['za'] },
    };

    const {
        placePredictions,
        getPlacePredictions,
        isPlacePredictionsLoading
    } = useGoogle({
        apiKey: document._portalConfig.apiKeyMap,
        options,
    });

    const onChangeInput = (value) => {
        if(!value.includes('#')){
            setHideListItem(false);
            getPlacePredictions({ input: value });
            setValueAddress(value);
        }else{
            setValueAddress(value);
            let strAddress = value.split('#');
            if(strAddress && strAddress[1]){
                setISPLocation(strAddress[1]);
            }
        }
    };

    const onCheckAddress = async () => {
        // console.log("valueAddress===", valueAddress)
        if(valueAddress.includes('#')){
            await props.onCheckCoverage(1);
        }else {
            await props.onCheckCoverage(0);
        }
    }

    console.log("placePredictions===", placePredictions);
    // console.log("isPlacePredictionsLoading===", isPlacePredictionsLoading);

    return (
        <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" id="check_coverage">
            <CustomDivider />
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Typography variant='h1' color='primary'>{t('check_your_coverage')}</Typography>
            </Grid>
            <Grid xs={12} item marginTop={0.5} container justifyContent="center">
                <Typography variant='p' color='primary'>{t('check_your_coverage_desc')}</Typography>
            </Grid>
            {/* <Grid item xs={12} container marginTop={2} spacing={1} className={classes.search_by} >
                <Grid item xs={3}>
                    <Grid xs={12} sm={12} item className={classes.input}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="custom-select-label">{"Search by"}</InputLabel>
                            <Select
                                labelId="custom-select-label"
                                id="custom-select"
                                fullWidth
                                onChange={(e) => {
                                    console.log("onchange e===", e)
                                    setSearchType(e.target.value);
                                }}
                                value={searchType}
                                className={classes.select_container}
                                inputProps={{ className: classes.select_input }}
                                label={t('Search by')}
                            >
                                <MenuItem value={0}>{t('Address')}</MenuItem>
                                <MenuItem value={1}>{t('Location reference')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={7}>
                    {searchType === 0 ? <GooglePlacesAutocomplete
                        apiKey={document._portalConfig.apiKeyMap}
                        autocompletionRequest={{
                            componentRestrictions: {
                                country: ['za'],
                            }
                        }}
                        selectProps={{
                            address,
                            onChange: props.setAddress,
                            controlShouldRenderValue: address ? true : false,
                        }}
                    /> :
                        <TextField
                            name="search_address"
                            id="search_address"
                            className={classes.input_container}
                            InputProps={{
                                classes: {
                                    root: classes.inputContainer,
                                    input: classes.inputRoot,
                                    focused: classes.inputContainerFocus,
                                    underline: classes.underline,
                                    multiline: classes.textArea,
                                },
                            }}
                            value={ispLocation}
                            onChange={(e) => setISPLocation(e.target.value)}
                        />
                    }
                </Grid>
                <Grid item xs={2}>
                    {searchType === 0 && <Button size="small" color='primary' variant='outlined' onClick={() => props.setAddress(null)}>
                        {t('Clear')}
                    </Button>}
                </Grid>
            </Grid> */}
            <Grid item xs={12} style={{ position: 'relative' }}>
                <Grid item xs={12}>
                    <TextField
                        name="new_search_address"
                        id="new_search_address"
                        className={classes.input_container}
                        InputProps={{
                            classes: {
                                root: classes.inputContainer,
                                input: classes.inputRoot,
                                focused: classes.inputContainerFocus,
                                underline: classes.underline,
                                multiline: classes.textArea,
                            },
                        }}
                        value={valueAddress}
                        onChange={(e) => onChangeInput(e.target.value)}
                    />
                </Grid>
                {placePredictions && hideListItem === false && <Grid item xs={12} className={classes.list_item}>
                    {placePredictions.length > 0 &&
                        placePredictions.map((item, index) => {
                            return (
                                <ListItem key={index} onClick={() => {
                                    props.setAddress(item);
                                    setValueAddress(item.description)
                                    setHideListItem(true);
                                }} className={classes.item_address} button>
                                    <ListItemIcon>
                                        <PlaceIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={item.description} />
                                </ListItem>
                            );
                        })}
                </Grid>}
            </Grid>
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Button color='primary' variant='contained' onClick={() => onCheckAddress()}>
                    {t('btn_check_coverage')}
                </Button>
            </Grid>
        </Grid>
    )
}

function SelectPackages(props) {
    const { packages, choosePackage, addressSelected } = props;
    const { t } = useTranslation();
    let hideVumacoreProducts = document._portalConfig.hideVumacoreProducts;
    return (
        <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" id="packages" ref={props.packagesRef}>
            <CustomDivider />
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Typography variant='h1' color='primary'>{t('select_your_package')}</Typography>
            </Grid>
            <Grid xs={12} item marginTop={0.5} container justifyContent="center">
                <Typography variant='p' color='primary'>{t('select_your_package_desc')}</Typography>
            </Grid>
            {/* <Packages packages={packages.vumatel} onClickItem={props.onClickItem}/>
            <Packages packages={packages.lte} onClickItem={props.onClickItem}/> */}
            {packages && packages.vuma_reach && packages.vuma_reach.length > 0 && <Grid item xs={12} id="section-product-vr">
                <Packages 
                packages={packages.vuma_reach.sort(sortByPrice)} 
                onClickItem={props.onClickItem} 
                choosePackage={addressSelected && addressSelected.product_types === 'VR' ? true : false} 
            />
            </Grid>}
            {!hideVumacoreProducts && packages && packages.vuma_core && packages.vuma_core.length > 0 && <Grid item xs={12} id="section-product-vc">
                <Packages 
                    packages={packages.vuma_core.sort(sortByPrice)} 
                    onClickItem={props.onClickItem} 
                    choosePackage={addressSelected && addressSelected.product_types === 'VC' ? true : false} 
                />
            </Grid>}
        </Grid>
    )
}

// function Packages(props){
//     const {packages, choosePackage} = props;
//     const classes = useStyles();
//     return(
//         <Grid xs={12} item marginTop={3} container direction="row" spacing={2}>
//             {packages.map((item,index) => {
//                 if(item.sku !== 'Initial Payment Service')
//                     return (
//                         <Grid key={index} xs={6} sm={6} md={6} lg={3} className={choosePackage ? classes.canSelected : null} item onClick={choosePackage ? () => props.onClickItem(item) : () => {}}>
//                             <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
//                         </Grid>
//                     )
//             })}
//         </Grid>
//     )
// }

function Packages(props) {
    const { packages, choosePackage } = props;
    const classes = useStyles();
    console.log("packages===", packages);
    return (
        <Grid xs={12} item marginTop={3} container direction="row" justifyContent={'center'} spacing={2}>
            {packages.map((item, index) => {
                return (
                    <Grid key={index} xs={6} sm={6} md={6} lg={3} className={choosePackage ? classes.canSelected : classes.cantSelected} item onClick={choosePackage ? () => props.onClickItem(item) : () => { }} title={item.product && item.product.name ? item.product.name : null}>
                        {item.image_url ? <img className={classes.item_image} src={item.image_url}/>
                            : <img className={classes.item_image_logo} src={getLogo()} />}
                    </Grid>
                )
            })}
        </Grid>
    )
}

function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image_logo} src={getLogo()} />;
}
